"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
var defaultJoinIdPath = function (value, parent) {
    if (!parent || !parent.id || !value || !value.id) {
        if (process.env.NODE_ENV === 'development') {
            console.warn('Failed to create path for: ', value, parent);
        }
        return value;
    }
    return __assign(__assign({}, value), { id: index_1.joinIdPath(parent.id, value.id) });
};
exports.default = defaultJoinIdPath;
//# sourceMappingURL=defaultJoinIdPath.js.map